import { FC } from "react";
import { GiftIcon, LockIcon } from "shared/ui/icons";
import { WheelRaffleItemStatus } from "../model/types";
import type { RaffleBase } from "../model/types";
import { IconBox } from "./IconBox";
import { RaffleTimer } from "./RaffleTimer";
import { WheelRaffleStatusBadge } from "./WheelRaffleStatusBadge";

import styles from "./RaffleHeader.module.css";

interface Props {
  raffle: RaffleBase;
}

// Сводка над колесом: что разыгрываем и сколько осталось.
export const RaffleHeader: FC<Props> = ({ raffle }) => (
  <header className={styles.header}>
    <div className={styles.main}>
      <IconBox size="lg">
        <GiftIcon fill="currentColor" width={28} height={28} />
      </IconBox>
      <div className={styles.block}>
        <div className={styles.title}>
          <h1 className={styles.name}>Promo #{raffle.id}</h1>
          <WheelRaffleStatusBadge status={raffle.status} />
          {raffle.visibility === "private" && (
            <span
              className={styles.lock}
              role="img"
              aria-label="Private"
              title="Private"
            >
              <LockIcon width={16} height={16} />
            </span>
          )}
        </div>
        <span className={styles.pool}>
          {raffle.prize_pool_usdt} <span className={styles.currency}>USDT</span>
        </span>
      </div>
    </div>
    {raffle.status !== WheelRaffleItemStatus.DRAWN && (
      <div className={`${styles.block} ${styles.time}`}>
        <span className={styles.label}>Time left</span>
        <RaffleTimer endsAt={raffle.ends_at} className={styles.timer} />
      </div>
    )}
  </header>
);
